import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Button, ButtonToolbar, Popover} from 'react-bootstrap'
import PatrimonyPicker from '../../patrimony/components/PatrimonyPicker'
import {sendAssociateProviderContactWithPatrimonyCmd, sendDissociateProviderContactFromPatrimonyCmd, loadContact} from '../actions'
import i18n from '../i18n'

class AssociateDissociateProviderContactFromPatrimonyPopover extends Component {

    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    _sendAssociateCmd(patrimony) {
        const {dispatch, user} = this.props
        
        return dispatch(sendAssociateProviderContactWithPatrimonyCmd(patrimony.uid)).then(() => {
            return dispatch(loadContact())
        })
    }

    _sendDissociateCmd(patrimony) {
        const {dispatch, user} = this.props

        return dispatch(sendDissociateProviderContactFromPatrimonyCmd(patrimony.uid)).then(() => {
            return dispatch(loadContact())
        })
    }

    _sendCmd(action, patrimony) {
        if (action == 'Add') return this._sendAssociateCmd(patrimony)
        if (action == 'Remove') return this._sendDissociateCmd(patrimony)
    }

    render() {
        const {dispatch, contact, onHide, ...others} = this.props

        return (
            <Popover
                bsClass='popover-lg popover'
                title={i18n.associateDissociatePatrimonies}
                {...others}>
                <PatrimonyPicker multi split
                    company={contact.company}
                    value={contact.patrimonies}
                    onSubmit={(a, p) => this._sendCmd(a, p)} />
                <ButtonToolbar>
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </Popover>
        )
    }
}

AssociateDissociateProviderContactFromPatrimonyPopover = connect((state) => ({
    contact: state.provider.contact.contact
}))(AssociateDissociateProviderContactFromPatrimonyPopover)

export default AssociateDissociateProviderContactFromPatrimonyPopover


// WEBPACK FOOTER //
// ./lib/provider/components/AssociateDissociateProviderContactFromPatrimonyPopover.js